
import { Col, Row, Skeleton } from 'antd';
import { get } from "lodash";
import React, { useEffect, useState, Suspense, lazy } from 'react';
import { connect, useDispatch } from 'react-redux';
import { handleListClassSubmissions } from 'store/submissions/thunks';
import { handleListClassActivities } from 'store/classActivities/thunks';
import { handleListClassUsers } from 'store/userClasses/thunks';
import { useApExams } from 'store/apexams/selectors';
import SentryWrap from 'components/Sentry';

const ExamTablesAp = lazy(() => import('features/ExamGradeTableAp'));

const ApGradeBookSkeleton = () => (
  <div style={{ width: '100%' , marginTop: 24, backgroundColor: '#f1f3f7' }}>
    <div style={{ display: 'flex', alignItems: 'flex-start', gap: 16, flexWrap: 'wrap', marginBottom: 24 }}>
      <Skeleton.Avatar active shape="square" style={{ width: 100, height: 100, borderRadius: 50 }} />
      <div style={{ flex: '1 1 240px', minWidth: 0 }}>
        <Skeleton.Input active style={{ width: 'min(420px, 100%)', height: 22, marginBottom: 14 }} />
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
          {[72, 72, 88, 100].map((w, i) => (
            <Skeleton.Button key={i} active style={{ width: w, height: 34 }} />
          ))}
        </div>
      </div>
    </div>
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
      <Skeleton.Avatar active size="small" shape="square" style={{ borderRadius: 6 }} />
      <Skeleton.Input active style={{ width: 140, height: 22 }} />
    </div>
    <div style={{ overflowX: 'auto', paddingBottom: 8 }}>
      <div style={{ display: 'flex', gap: 10, minWidth: 640 }}>
        <div style={{ width: 230, flexShrink: 0 }}>
          {Array.from({ length: 7 }).map((_, i) => (
            <Skeleton.Input key={i} active size="small" style={{ width: '100%', height: 45, marginBottom: 8, borderRadius: 5 }} />
          ))}
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: 'flex', gap: 6, marginBottom: 8, flexWrap: 'nowrap' }}>
            {Array.from({ length: 10 }).map((_, i) => (
              <Skeleton.Input key={i} active size="small" style={{ width: 70, height: 25, flexShrink: 0, borderRadius: 5 }} />
            ))}
          </div>
          {Array.from({ length: 6 }).map((_, row) => (
            <div key={row} style={{ display: 'flex', gap: 6, marginBottom: 8 }}>
              {Array.from({ length: 10 }).map((_, col) => (
                <Skeleton.Input key={col} active size="small" style={{ width: 70, height: 45, flexShrink: 0, borderRadius: 5 }} />
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export const ApGradeBook = ({
    classActivities,
    classQuizzes,
    currentClass,
    classUsers,
    submissions,
    activities,
    quizzes,
}) => {
 

    const dispatch = useDispatch()
    const [dataLoading, setDataloading] = useState(false)
    const [refreshLoading, setRefreshLoading] = useState(false)
    const exams = useApExams()
    const sortExam = () => {
        if (exams) {
            return exams.sort((a, b) => {
                if (a.order > b.order) {
                    return 1
                }
                if (a.order < b.order) {
                    return -1
                }
                return 0
            })
        } else {
            return [];
        }
    }
 
    const listCurrentClassInfo = async () => {
        if (get(currentClass, "id")) {
          await Promise.allSettled([  
            dispatch(handleListClassUsers(get(currentClass, "id"))),
            dispatch(handleListClassActivities(get(currentClass, "id"))),
            dispatch(handleListClassSubmissions(get(currentClass, "id"),false,null,true,true))
          ])
        }
    }
 

    const fetchApis = async () => {
        setDataloading(true)
        await listCurrentClassInfo()
        setDataloading(false)
    }

    const refreshApis = async () => {
        setRefreshLoading(true)
        try {
            await listCurrentClassInfo()
        } finally {
            setRefreshLoading(false)
        }
    }

    useEffect(() => {
        fetchApis()
    }, [])

  return (<SentryWrap>
      <div>
        <div className="container">
          <Row>
            <Col xs={24} sm={24} md={24} lg={24}>
              <div className="dataColloect">
                <Row className="storyDataWrap">
                  <Col xs={24} sm={24} md={24} lg={24}>
                    <div style={{ marginTop: 24, backgroundColor: '#f1f3f7' }}>
                      {dataLoading ? (
                        <ApGradeBookSkeleton />
                      ) : (
                        <div>
                          <Suspense fallback={<ApGradeBookSkeleton />}>
                            <ExamTablesAp
                              activities={activities}
                              dataLoading={dataLoading}
                              refreshLoading={refreshLoading}
                              onRefresh={refreshApis}
                              quizzes={quizzes}
                              users={classUsers}
                              submissions={submissions}
                              classActivities={classActivities}
                              classQuizzes={classQuizzes}
                              exams={sortExam()}
                            />
                          </Suspense>
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>
                {/* End of Data Table  */}
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </SentryWrap>);
};
const mapStateToProps = state => ({
    classActivities: state.classActivities,
    classQuizzes: state.classQuizzes,
    currentUser: state.currentUser,
    classUsers: state.classUsers,
    currentClass: state.currentClass,
    submissions: state.submissions,
    activities: state.activities,
    quizzes: state.quizzes
});

export default connect(mapStateToProps, null)(ApGradeBook); 